module.exports = __webpack_public_path__ + "img/Southwest Quinoa Bowl-Shrimp.b50a2a2e.jpg";